import { personalizedResource } from '@/lib/resources/personalized-resource';

// types
import type { ContinueWatchingContent } from '@/lib/types/api/home-data'

export const continueWatching = personalizedResource<ContinueWatchingContent>({
  key: 'continueWatching',
  endpoint: '/api/profile/continue-watching/',
  select: (json) => (json as { continueWatchingData: ContinueWatchingContent[] | null }).continueWatchingData,
})
